import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { DASHBOARD_STUDENT, DASHBOARD_V2_STUDENT, GLOBAL_STATE } from '../constants/actionTypes'

const studentDashboardSelectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const studentDashboardSelector = createSelector(studentDashboardSelectors, data => data[DASHBOARD_STUDENT])
export const studentDashboardV2Selector = createSelector(studentDashboardSelectors, data => data[DASHBOARD_V2_STUDENT])
